/**
 * headerConstants
 *
 * @package                onboard
 * @subpackage             headerConstants
 * @category               Constants
 * @DateOfCreation         22 May 2019
 * @ShortDescription       This is responsible for Header action names
 */
export const headerConstants = {
    LOGOUT_SUCCESS          : 'LOGOUT_SUCCESS',
    LOGOUT_FAILURE			: 'LOGOUT_FAILURE'
};
